import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const PayTRModal = ({ token, onClose, onSuccess }) => {
  useEffect(() => {
    // PayTR callback listener - Sadece PayTR'dan gelen resmi postMessage'a güven
    const handleMessage = (event) => {
      // PayTR'dan gelen mesajları dinle
      if (event.origin === 'https://www.paytr.com') {
        try {
          let data = event.data;
          
          // String ise JSON parse et (ama JSON olmayabilir, dikkatli ol)
          if (typeof data === 'string') {
            // Sadece JSON gibi görünen stringleri parse et
            if (data.startsWith('{') || data.startsWith('[')) {
              try {
                data = JSON.parse(data);
              } catch (parseError) {
                // JSON değil, log et ve devam et
                console.log('PayTR non-JSON message:', data.substring(0, 100));
                return; // JSON parse edilemezse işlem yapma
              }
            } else {
              // String ama JSON değilse işlem yapma
              return;
            }
          }
          
          // SADECE status === 'success' olduğunda işlem yap
          if (data && data.status === 'success') {
            console.log('Payment successful via postMessage! Closing modal...');
            // Önce modal'ı kapat
            onClose();
            
            // Sonra başarı callback'ini çağır (yönlendirme yapacak)
            if (onSuccess) {
              setTimeout(() => {
                onSuccess();
              }, 100); // Modal kapandıktan sonra callback'i çağır
            }
          } else if (data && data.status === 'failed') {
            console.log('Payment failed via postMessage');
            alert('Ödeme başarısız oldu. Lütfen tekrar deneyin.');
            onClose(); // Başarısız olunca da kapat
          }
          // Diğer durumlarda hiçbir şey yapma - ödeme devam ediyor demektir
          
        } catch (e) {
          // Sessizce log et
          console.log('PayTR message handler error:', e.message);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onSuccess, onClose]);

  if (!token) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-bold text-gray-900">Güvenli Ödeme</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="relative" style={{ height: '600px' }}>
          <iframe
            src={`https://www.paytr.com/odeme/guvenli/${token}`}
            id="paytriframe"
            frameBorder="0"
            scrolling="yes"
            style={{ width: '100%', height: '100%' }}
            title="PayTR Güvenli Ödeme"
            allow="payment"
            // CSP uyarılarını azaltmak için sandbox attribute'u ekle
            // PayTR'nin çalışması için gerekli izinleri ver
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
          />
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between p-4 border-t bg-gray-50">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span>256-bit SSL Şifreli Güvenli Ödeme</span>
          </div>
          <button
            onClick={() => {
              // SADECE modal'ı kapat - ödeme başarısını tetikleme!
              // Ödeme durumu sadece PayTR callback'i ile güncellenir
              onClose();
            }}
            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg text-sm font-medium transition-colors"
          >
            ✕ İptal Et
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayTRModal;
